import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../context/API_Client";
import LoadingLogoPage from "../../../loadingPage/loadingPage";
import BoxPayGrid from "../../../BoxPayGrid";
import CustomButton from "../../../../reusableComponents/CustomButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import AllWebhookSchema from "./AllWebhookSchema";
import SmallModal from "../../../../reusableComponents/modals/SmallModal";
import WebhookIcon from "@mui/icons-material/Webhook";
import EmptyState from "../../../../reusableComponents/ConfigEmptyState/EmptyState";
import { customToast } from "../../../../reusableComponents/customToaster/customToast";
import { Typography } from "@mui/material";
import { colorBrandObject } from "../../../../../constants/brandings";
import FileCopyIcon from "../../../../../assets/svg/fileCopy.svg";

const handleCopy = (val, msz) => {
  navigator.clipboard.writeText(val);
  customToast("success", "medium", msz);
};

export const SaltKeyComponent = ({ pass, hidden = true, msz = '', label }) => {
  return (
    <div className="salt-id">
      <div className="txn-id-copy-btn">
        <Typography className="labelSemiBold font-text-low" sx={{ marginLeft: "6px" }}  >
          {label}
        </Typography>
        <Typography className="bodyB2SemiBold" sx={{ marginRight: "4px", marginTop: "6px" }}  >
          {hidden ? ('********') : (pass)}
        </Typography>
      </div>
      <div className="txn-id-copy-btn">
        <div className="copy-button" onClick={() => handleCopy(pass, msz)} >
          <FileCopyIcon stroke={`${colorBrandObject?.actionIconColor}`} />
        </div>
      </div>
    </div>
  )
}

export default function AllWebhooks({ operationPermissions }) {
  const {
    getAllWebhookDetails,
    deleteWebhookDetails,
    isAuthorizedPermission,
    getSaltKey,
  } = useAuth();
  const navigate = useNavigate();
  const [webhookData, setWebhookData] = useState([]);
  const [paymentError, setPaymentError] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteId, setDeleteId] = useState(null);
  const [editId, setEditId] = useState(null);
  const [editing, setEditing] = useState(false);
  const [toggleDialog, setToggleDialog] = useState(false);
  const [saltKey, setSaltKey] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();

  const removeQueryParams = () => {
    const param = searchParams.get("webhookUrl");
    if (param) {
      searchParams.delete("webhookUrl");
      setSearchParams(searchParams);
    }
  };

  useEffect(() => {
    if (
      !sessionStorage.getItem("webhooksAndLogsTab") ||
      sessionStorage.getItem("webhooksAndLogsTab") == 0
    ) {
      getSaltKey(
        (data) => {
          setSaltKey(data?.saltKey);
        },
        (errorMsg) => {
          setPaymentError(errorMsg);
          customToast("error", "high", errorMsg);
        }
      );
      removeQueryParams();

      getAllWebhookDetails(
        (data) => {
          setWebhookData(data);
          setLoading(false);
        },
        (errorMsg) => {
          setPaymentError(errorMsg);
          customToast("error", "high", errorMsg);
          setLoading(false);
        }
      );

      const newWebhook = localStorage.getItem("webhookCreated");
      {
        newWebhook &&
          customToast(
            "success",
            "high",
            `Webhook Config test results passed and saved successfully`
          );
      }
      localStorage.removeItem("webhookCreated");
    }
  }, []);

  const editWebhookData = (value) => {
    setEditing(true);
    setEditId(value);
  };

  useEffect(() => {
    if (editing) {
      navigate("/developers/webhooks/editWebhook?webhookId=" + editId, {
        state: { editing, editId },
      });
    }
  }, [editing]);

  const deleteWebhookData = (deleteId) => {
    setDeleteId(deleteId);
    setToggleDialog(true);
  };

  const handleDeleteToggleBtn = () => {
    deleteWebhookDetails(
      deleteId,
      function (data) {
        setDeleteId(null);
        getAllWebhookDetails(
          (data) => {
            setWebhookData(data);
            setToggleDialog(false);
            customToast("success", "high", `Webhook Deleted Successfully`);
          },
          (errorMsg) => {
            setPaymentError(errorMsg);
            customToast("error", "high", errorMsg);

            setLoading(false);
          }
        );
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  };

  return (
    <>
      {loading ? (
        <div>
          <section
            style={{
              display: "flex",
              marginTop: "24px",
              justifyContent: "center",
              alignItems: "center",
              height: loading ? "50vh" : "auto",
            }}
          >
            <LoadingLogoPage />
          </section>
        </div>
      ) : webhookData?.length > 0 ? (
        <section className="mainDivWebHooks">
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "end",
            }}
          >
            {<SaltKeyComponent pass={saltKey} msz={'Salt key copied'} label={'Salt Key:'} />}
            {isAuthorizedPermission(operationPermissions?.createWebhook) && (
              <CustomButton
                text={"Create Webhook"}
                type={"primary"}
                variant={"contained"}
                size={"sm"}
                onClick={() => {
                  navigate("/developers/webhooks/createWebhook", {
                    state: { editing },
                  });
                  setEditing(false);
                }}
              />
            )}
          </div>
          <div style={{ marginTop: "32px", width: "100%", display: "flex" }}>
            <BoxPayGrid
              schema={AllWebhookSchema(
                deleteWebhookData,
                editWebhookData,
                operationPermissions
              )}
              data={webhookData}
              showCustomizeButton={false}
            />
          </div>

          <SmallModal
            headerText={"Are you sure you want to delete this Webhook?"}
            subHeaderText={
              "By deleting this webhook configuration, you will no longer receive notifications at this URL"
            }
            outlinedBtnText={"Cancel"}
            filledBtnText={"Delete"}
            outlinedBtnFunction={() => setToggleDialog(false)}
            filledBtnFunction={handleDeleteToggleBtn}
            toggleDialog={toggleDialog}
            icon={<img src="/assets/routingIcons/ExclamationCircle.svg" />}
            type={"error"}
          />
        </section>
      ) : (
        <>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "end",
              marginBottom: '2rem',
            }}
          >
            <SaltKeyComponent pass={saltKey} msz={'Salt key copied'} label={'Salt Key:'} />
          </div>
          <div
            style={{
              backgroundColor: "white",
              width: "100%",
              borderRadius: "16px",
              border: "1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12))",
            }}
          >


            <EmptyState
              image={
                <WebhookIcon
                  sx={{
                    color: "rgba(201, 201, 204, 1)",
                    height: "120px",
                    width: "120px",
                  }}
                />
              }
              mainText={"Webhooks Logs"}
              subText={"Chronological record of webhook log activity"}
              btnText={"Create Webhook"}
              btnFunction={() => navigate("/developers/webhooks/createWebhook")}
              btnPermission={operationPermissions?.createWebhook}
            />
          </div>
        </>
      )}
    </>
  );
}
